// Copyright 2022 Sorama B.V.

import { bindable, customElement } from "aurelia-framework";
import { IAuthentication } from "libraries/Authentication/IAuthentication";
import { RepresentativeRepository } from "repositories/RepresentativeRepository";
import { RepresentativeDTO } from "./../../../datatypes/SoramaWebApi";

@customElement("headerlogo")
export class HeaderLogo {
    public representative: RepresentativeDTO;
    @bindable isAnimated: boolean;

    constructor(
        private readonly authentication: IAuthentication,
        private readonly representativeRepository: RepresentativeRepository
    ) {}

    public async bind(): Promise<void> {
        this.representativeRepository
            .getRepresentative(this.authentication.userId)
            .then((representative) => (this.representative = representative))
            .catch((e) => console.error(e));
    }
}
